import { render, staticRenderFns } from "./headMenu3.vue?vue&type=template&id=e40ebc98&scoped=true"
import script from "./headMenu3.vue?vue&type=script&lang=js"
export * from "./headMenu3.vue?vue&type=script&lang=js"
import style0 from "./headMenu3.vue?vue&type=style&index=0&id=e40ebc98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40ebc98",
  null
  
)

export default component.exports